const genererEtapeInformation = () => {
  return {
    prestationFournisseurId: null,
    lieuLivraisonId: null,
    produitPrestationId: null,
    annonceurCommande: false,
  };
};

const genererFormatAffiche = () => {
  return {
    code: '',
    libelle: '',
    largeur: null,
    longueur: null,
    societeId: null,
    typeMaterielId: null,
    natureSupportAfficheId: null,
    visuel: genererEtapeInformation(),
    impression: genererEtapeInformation(),
    faconnage: genererEtapeInformation(),
    expedition: genererEtapeInformation(),
  };
};

export default genererFormatAffiche;
